import { ESiteType } from '../../types/page';

type TNewbuildingAnchor = '#promoList' | '#new-promos-anchor-landing';

export const getNewbuildingPromosAnchor = (siteType: ESiteType): TNewbuildingAnchor => {
  switch (siteType) {
    case ESiteType.mobile:
    case ESiteType.tablet:
      return '#new-promos-anchor-landing';
    case ESiteType.desktop:
      return '#promoList';
  }
};
